export const MAPBOX =
    'pk.eyJ1IjoibWFzZXJhc3RpIiwiYSI6ImNrYTl0YzNxZDA4bXoyc29pdWt0cXB1b3cifQ.hRPCMmBWGyoaReADKDy6JQ'

export const GOOGLE_ANALYTICS = 'UA-156087000-1'
export const GOOGLE_ADS = 'AW-658431654'
export const AD_TRACK = 'Ptv8CJXwl9IBEKa9-7kC'
export const GOOGLE_RECAPTCHA = '6LdxFvoUAAAAAMnq_3jGCh3BNlRycqqLvzwraTQq'

export const HOTJAR_ID = '2173101'
